const FeedBillsIcon = (props: any) => {
    return (
        <img {...props} alt="settings.png" src={require('./settings.png')} />
    );
};

export default FeedBillsIcon;
